export const getRecipeTypeChipsToRender = (recipeTypeChips, maxChips) => {
    if (recipeTypeChips.length <= maxChips) {
        return recipeTypeChips;
    }
    return recipeTypeChips.slice(0, maxChips).map((rt, index, arr) => {
        const isLast = index === arr.length - 1;
        if (isLast) {
            const remainingChips = recipeTypeChips.length - (maxChips - 1);
            return {
                label: `+${remainingChips} more...`,
                clickable: true,
            };
        }
        return rt;
    });
};
